import React from 'react';
import Layout from './components/Layout';
import Unauthorized from './components/Unauthorized';
import Page from './pages/Page';
import CreateUser from './pages/users/CreateUser';
import EditUser from './pages/users/EditUser';
import UserList from './pages/users/UserList';
import ManageDocuments from './pages/ManageDocuments';
import Settings  from './pages/Settings';
import LoginForm from './pages/LoginForm';
import RequireAuth from './components/RequireAuth';

import { Routes, Route } from 'react-router-dom';

class App extends React.Component {
  render() {
    return (   
      <Routes>
            <Route element={<Layout />}>              
                {/* Public routes */}
                <Route path="Login" element= {<LoginForm />} />
                <Route path="CreateUser" element={<CreateUser />} />
                <Route path="Unauthorized" element={<Unauthorized />} />

                {/* Protected routes */}
                <Route element={<RequireAuth />}>
                  <Route index element={<Page />} />
                  <Route path="EditUser" element={<EditUser />} />
                  <Route path="UserList" element={<UserList />} />
                  <Route path="ManageDocuments" element={<ManageDocuments />} />
                  <Route path="Settings" element={<Settings />} />
                </Route>
            </Route> 
        </Routes>          
    );
  }
}

export default App;
